import * as React from "react";
const SvgFiRrTree = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tree_svg__a)">
      <path
        fill="#062147"
        d="M20.467 17.3a530 530 0 0 0-1.557-1.815 2.67 2.67 0 0 0 .616-3.663c-.025-.036-1.885-2.09-1.885-2.09.465-.235.845-.61 1.084-1.074a2.43 2.43 0 0 0-.176-2.526C18.528 6.1 13.886.846 13.886.846a2.61 2.61 0 0 0-3.771 0S5.472 6.1 5.451 6.13a2.43 2.43 0 0 0-.176 2.526c.24.463.619.839 1.084 1.073 0 0-1.859 2.055-1.885 2.091a2.67 2.67 0 0 0 .616 3.663S3.554 17.268 3.533 17.3A3 3 0 0 0 6 22h5v1a1 1 0 0 0 2 0v-1h5a3 3 0 0 0 2.471-4.7zm-1.585 2.167A.99.99 0 0 1 18 20H6a1 1 0 0 1-.85-1.529l2.135-2.47H13a1 1 0 1 0 0-2H6.67a.668.668 0 0 1-.578-1l2.722-3H12a1 1 0 1 0 0-2H7.5a.49.49 0 0 1-.451-.265.42.42 0 0 1 .01-.418l4.552-5.149a.51.51 0 0 1 .773 0l4.55 5.148a.41.41 0 0 1 .011.418A.49.49 0 0 1 16.5 8h-.868a1.006 1.006 0 0 0-.74 1.672L17.908 13a.666.666 0 0 1-.578 1h-.157a1.007 1.007 0 0 0-.757 1.653l2.43 2.818a.98.98 0 0 1 .036.994z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tree_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTree;
